import { Component, Inject } from "@angular/core";
import { MatDialogRef } from "@angular/material";
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: "success-popup",
    template: require('./success-popup.component.html'),
    styles: [require('./success-popup.component.less')],
})

export class SuccessPopupComponent {

    constructor(
        public successPopup: MatDialogRef<any>,
        @Inject(MAT_DIALOG_DATA) public data : any
    ) { }

    paymentSuccessPopupClose() {
        this.successPopup.close();
    }

}
